import React, {useState, useEffect} from 'react';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {useSessionStore} from '../../hooks/useSessionStore';
import axios from 'axios';
import { createSearchParams, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import eslogan from './img/eslogan.png'
import './style.css';
import { BuscadorLocalidad } from './BuscadorLocalidad';

export const BuscadorHome = (props) =>{
    const {
		Empresas,
		setEmpresas,
		mapa,
		setMapa,
		setModalUbiacion,
		setEmpresasCargadas,
		getEmpresas_preRegistradas,
		limite,
		setBuscarNombre,
		setBuscarCategoria,
		setBuscarLocalidad,
		setBuscarProvincia,
	} = props;

	const navigate = useNavigate()

    const [ListaProvincias, setListaProvincias] = useState([]);

	const [showLocalidades, setShowLocalidades] = useState(false);
    const [ListaLocalidades, setListaLocalidades] = useState([]);
	const [Provincia, setProvincia] = useState({
		nombre: 'Todas',
		id: 0,
	});

    const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
    const [NombreBuscar, setNombreBuscar] = useState(''.toString());
	const [busqueda, setBusqueda] = useState('')

    const [localidadSeleccionada, setLocalidadSeleccionada] = useState([])
    const [Localidad, setLocalidad] = useState({
		nombre: '',
		id: 0,
	});

	const [Ubicacion, setUbicacion] = useState({
		lat: '38.57065590139325',
		lng: ' -6.196927275067296'
	})

    const [Categorias, setCategorias] = useState([]);
	const [CategoriaSeleccionada, setCategoriaSeleccionada] = useState({
		nombre: '',
		id: 0,
	});

	const categoriasPrincipales = [
		'Todas',
		'Valoración geriátrica integral',
		'Tablet estimulación cognitiva, telemedicina, etc',
		'Fisioterapia', 
		'Podología',
		'Peluquería',
		'Ayuda a domicilio',
		'Peluquería canina',
		'Paseo y cuidado de mascotas',
		'Acompañamiento geriátrico integral'
	]

    useEffect(() => {
        definirCategorias();
		// definirLocalidades();
		setProvincia({
			nombre: 'Todas',
			id: 0,
		});
	}, []);

	useEffect(()=>{
		const localidadStorage = localStorage.getItem('localidades')
		if(localidadStorage){
			const localidades = JSON.parse(localidadStorage);
			let listaAux = [{'id':0,'nombre':'Todas'}]
			localidades.forEach((localidad)=>{
				listaAux.push({
					id: localidad.id,
					nombre: localidad.nombre,
					provincia: localidad.provincia
				})
			})

			setListaLocalidades(listaAux);
		}
	},[])

	// useEffect(() => {
	// 	if (Provincia.id !== undefined) {
	// 		axios({
	// 			method: 'get',
	// 			// url: window.ipdirection + 'localidadAll/?id_prov=' + Provincia.id,
	// 			url: window.ipdirection + 'localidadAll'
	// 		}).then((response) => {
	// 			console.log('BuscadorHome ln. 71');
	// 			let listaAxu = [];
	// 			/* Mapping the response data and pushing it into an array. */
	// 			listaAxu.push({
	// 				nombre: 'Todas',
	// 				id: 0,
	// 			});
	// 			response.data.forEach((localidad) => {
	// 				listaAxu.push({
	// 					id: localidad.id,
	// 					nombre: localidad.nombre,
	// 					provincia: localidad.provincia,
	// 				});
	// 			});

	// 			setListaLocalidades(listaAxu);
	// 			setLocalidad({
	// 				nombre: 'Todas',
	// 				id: 0,
	// 			});
	// 		});
	// 	}
	// }, [Provincia]);

	// const definirLocalidades = () => {
	// 	axios({
	// 		method: 'get',
	// 		// url: window.ipdirection + 'localidadAll/?id_prov=' + Provincia.id,
	// 		url: window.ipdirection + 'localidadAll'
	// 	}).then((response) => {
	// 		let listaAxu = [];
	// 		/* Mapping the response data and pushing it into an array. */
	// 		listaAxu.push({
	// 			nombre: 'Todas',
	// 			id: 0,
	// 		});
	// 		response.data.forEach((localidad) => {
	// 			listaAxu.push({
	// 				id: localidad.id,
	// 				nombre: localidad.nombre,
	// 				provincia: localidad.provincia,
	// 			});
	// 		});

	// 		setListaLocalidades(listaAxu);
	// 		// setLocalidad({
	// 		// 	nombre: 'Todas',
	// 		// 	id: 0,
	// 		// });
	// 	});
	// }

    const definirCategorias = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'categoria/',
		})
			.then((response) => {
				let listaAxu = [];
				listaAxu.push({nombre: 'Todas', id: 0});
				response.data.map((categoria) => {
					listaAxu.push({...categoria});
				});
				setCategorias(listaAxu);
			})
			.catch((error) => {
				console.log(error);
			});
	};

    const selecionarCategoria = (event) => {
		setInputValue(event)
        setBusqueda(event)
		Categorias.map((categoria) => {
			if (categoria.nombre.toLowerCase() === event.toLowerCase()) {
				setCategoriaSeleccionada(categoria);
				setShowCategorias(false);
			}
		});
	};

    const selecionarLocalidad = (event) => {
		if (event.length > 4) {
			setShowLocalidades(true);
		}else {
			setShowLocalidades(false);
		}
		const [localidad_event, provincia_event] = event.split(', ')
		ListaLocalidades.forEach((localidad) => {
			if (localidad.nombre.toLowerCase() === localidad_event.toLowerCase() && localidad.provincia.nombre.toLowerCase() === provincia_event.toLowerCase()) {
				setLocalidad({...localidad});
			}
		});
	};

	useEffect(() => {
		cargarDatos();
	}, [NombreBuscar, CategoriaSeleccionada, Localidad, Provincia]);

	const cargarDatos = () => {
		setBuscarNombre(CategoriaSeleccionada.nombre);
		setBuscarCategoria(CategoriaSeleccionada.id);
		setBuscarLocalidad(Localidad.id);
		setBuscarProvincia(Provincia.id);
		return {
			nombreEmpresa: NombreBuscar,
			categoria_id: CategoriaSeleccionada,
			localidad_id: Localidad,
			provincia_id: Provincia,
		};
	};
	// const searchEmpresas = async () => {
	// 	let data = cargarDatos();
	// 	if (Usuario.tipo === 'usuarioNormal') {
	// 		axios({
	// 			/* Sending a post request to the server. */
	// 			method: 'post',
	// 			url: window.ipdirection + 'logs?logstream=buscarEmpresa',
	// 			headers: {
	// 				Authorization: 'Bearer ' + Usuario.access,
	// 			},
	// 			data: {
	// 				usuario: Usuario.cliente.usuario.id,
	// 				query: data.nombreEmpresa.toString(),
	// 				categoria: data.categoria_id.id,
	// 				localidad: data.localidad_id.id,
	// 				provincia: data.provincia_id.id,
	// 				accion: 'buscarEmpresa',
	// 			},
	// 		})
	// 			.then((response) => {})
	// 			.catch((error) => {});
	// 	}
	// 	console.log('data.localidad_id.id', data.localidad_id.id)
	// 	try {
	// 		// Recupera la lista de empresas.
	// 		const response = await axios({
	// 			method: 'get',
	// 			url:
	// 				window.ipdirection +
	// 				'busquedaAvanzada/?nombreEmpresa=' +
	// 				busqueda+
	// 				'&categoria_id=' +
	// 				data.categoria_id.id +
	// 				'&categoria_nombre=' +
	// 				busqueda+
	// 				'&localidad_id=' +
	// 				data.localidad_id.id +
	// 				'&provincia_id=' +
	// 				data.provincia_id.id,
	// 		});
	// 		console.log('response.data', response.data)
	// 		const empresas = response.data;

	// 		getEmpresas_preRegistradas();
	// 		imagenesEmpresa(empresas)
	// 	} catch (error) {
	// 		console.log(error);
	// 	}

	// 	}

		// const imagenesEmpresa = async (empresas) => {
		// 	console.log("BuscadorHome");
		
		// 	try {
		// 		// Crea una promesa por cada empresa para recuperar su imagen de perfil y crear una URL.
		// 		const empresasConImagenes = await Promise.all(
		// 			empresas.map(async (empresa) => {
						
		// 				try {
		// 					const imagenResponse = await axios.get(
		// 						window.ipdirection + `imagenPerfilEmpresaCliente/${empresa.id}/`,
		// 						{ responseType: 'blob' }
		// 					);
		// 					const imagenURL = URL.createObjectURL(imagenResponse.data);
		// 					// Devuelve un objeto que contiene los detalles de la empresa y la URL de su imagen de perfil.
		// 					return { ...empresa, img: imagenURL };
		// 				} catch (error) {
		// 					console.error(`Error obteniendo imagen para la empresa ${empresa.id}:`, error);
		// 					return {
		// 						...empresa,
		// 						img: 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images',
		// 					};
		// 				}
		// 			})
		// 		);
		
		// 		// Actualiza el estado Empresas con la lista de empresas que incluyen sus imágenes de perfil.
		// 		setEmpresas(empresasConImagenes);
		// 		console.log('Empresas actualizadas con imágenes:', empresasConImagenes);
		// 	} catch (error) {
		// 		console.error('Error en imagenesEmpresa:', error);
		// 	}
		// };

		const [showCategorias, setShowCategorias] = useState(false);
		const [inputValue, setInputValue] = useState('');
		const [mostrarMasCategorias, setMostrarMasCategorias] = useState(false);

		const handleInputChange = (e) => {
			console.log('categoria', e)
			const value = e;
			setInputValue(value);
			Categorias.forEach((categoria) => {
				if (categoria.nombre.toLowerCase() === value.toLowerCase()) {
					setCategoriaSeleccionada(categoria);
					setShowCategorias(!showCategorias)
				}
			});
		};

		const matchCategoria = (input, nombreCategoria) => {
			const normalize = (str) =>
				str
					.toLowerCase()
					.normalize("NFD")
					.replace(/[\u0300-\u036f]/g, ""); // Elimina acentos
	
			const inputWords = normalize(input).split(" ");
			const categoriaWords = normalize(nombreCategoria).split(" ");
	
			return inputWords.every((word) =>
				categoriaWords.some((cateWord) => cateWord.includes(word))
			);
		};

		const categoriasDivididas = () => {
			// Filtramos las categorías principales que existen en Categorias
			const principales = Categorias.filter(cat => 
			  categoriasPrincipales.includes(cat.nombre)
			);
			
			// El resto de categorías (excluyendo las principales)
			const resto = Categorias.filter(cat => 
			  !categoriasPrincipales.includes(cat.nombre)
			);
			
			return { principales, resto };
		  };
		  

    return (
		<div className='buscadorPorNombre_superior1'>
			{/* <div className='flex-grow flex flex-nowrap align-items-center justify-content-between'> 
				<div className='input-buscador p-3 rounded-2 flex-grow mx-1'>
					<input className="item-input bg-transparent text-dark" list="datalistOptions" id="exampleDataList" placeholder="¿Qué quieres?" onChange={(e)=>{selecionarCategoria(e.target.value);}}/>
					<datalist id="datalistOptions">
						{Categorias.map((categoria) => (
							<option key={categoria.id} value={categoria.nombre} />
						))}
					</datalist>
				</div>
				<div className='localidad-item-buscadorPorNombre item-buscador input-buscador p-3 rounded-2 flex-grow'> */}

						{/************************/}

					{/* <input className="item-input" list="datalistLocalidad" id="exampleDataList" placeholder="¿Dónde lo quieres?" onChange={(e)=>{selecionarLocalidad(e.target.value);}}/>
					{
						showLocalidades && (
							<datalist id="datalistLocalidad">
								{ListaLocalidades.map((localidad, index) => (
									<option key={localidad.id} value={localidad.nombre + ', ' + localidad?.provincia?.nombre} />
								))}
							</datalist>
						)
					} */}

						{/************************/}

					{/* <BuscadorLocalidad ListaLocalidades={ListaLocalidades} setLocalidad={setLocalidad}/>
				</div>

				<div className='item-buscadorPorNombre p-3 rounded-2 flex-grow'>
					<div
						className='btn btn-primary buttonBuscar2'
						onClick={
							// ()=>{navigate('/busqueda?q='+busqueda+'&lugar='+Localidad.id)}
							// ()=>{navigate('/busqueda',{state:{q:busqueda,lugar:Localidad.id}})}
							() => {
								navigate({pathname: 'busqueda',
									search: '?' + createSearchParams({q: busqueda, lugar:Localidad.id, categoria:CategoriaSeleccionada.id})
								})
							}
						}
					>
						<div className='centrador'>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='18'
								height='18'
								fill='currentColor'
								className='bi bi-search'
								viewBox='0 0 16 16'
							>
								<path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
							</svg>
						</div>
						<div>
							<b>BUSCAR</b>
						</div>
					</div>
				</div>
			</div> */}
			<div className="mt-4">
				<div className="search-bar">
					<div className="position-relative w-100">
						<input type='text' className="form-control bg-white text-dark" placeholder="Ej. Ayuda a domicilio, Podología..."
							value={inputValue}
							onChange={(e)=>{selecionarCategoria(e.target.value);}}
							onFocus={() => setShowCategorias(!showCategorias)}
							
						/>
						
						{
							showCategorias &&
							<ul className="dropdown-list">
								{/* {Categorias.slice(0, mostrarMasCategorias ? Categorias.length : 9).filter((categoria) =>
									matchCategoria(inputValue, categoria.nombre)
								).map((categoria) => (
									<li
										key={categoria.id}
										onClick={() => selecionarCategoria(categoria.nombre)}
									>
										{categoria.nombre}
									</li>
								))}
								<li className='text-center text-primary'
									onClick={() => setMostrarMasCategorias(!mostrarMasCategorias)}
								>
									{ !mostrarMasCategorias ? 'Mostrar más' : 'Mostrar menos'}
								</li> */}

								{
									categoriasDivididas().principales
									.filter(categoria => matchCategoria(inputValue, categoria.nombre))
									.map(categoria => (
										<li
										key={categoria.id}
										onClick={() => selecionarCategoria(categoria.nombre)}
										>
										{categoria.nombre}
										</li>
									))
								}
								
								{(mostrarMasCategorias || inputValue) && 
									categoriasDivididas().resto
									.filter(categoria => matchCategoria(inputValue, categoria.nombre))
									.map(categoria => (
										<li
										key={categoria.id}
										onClick={() => selecionarCategoria(categoria.nombre)}
										>
										{categoria.nombre}
										</li>
									))
								}
								
								{!inputValue && categoriasDivididas().resto.length > 0 && (
								<li 
									className='text-center text-primary'
									onClick={() => setMostrarMasCategorias(!mostrarMasCategorias)}
								>
									{mostrarMasCategorias ? 'Mostrar menos' : 'Mostrar más'}
								</li>
								)}
							</ul>
						}
					</div>
					<BuscadorLocalidad ListaLocalidades={ListaLocalidades} setLocalidad={setLocalidad}/>
                    <div
                        className='btn btn-search'
                        onClick={
                            // ()=>{navigate('/busqueda?q='+busqueda+'&lugar='+Localidad.id)}
                            // ()=>{navigate('/busqueda',{state:{q:busqueda,lugar:Localidad.id}})}
                            () => {
                                navigate({pathname: '/busqueda',
                                    search: '?' + createSearchParams({q: busqueda, lugar:Localidad.id, categoria:CategoriaSeleccionada.id})
                                })
                            }
                        }
                    >
                        <div className='centrador'>
                            <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='18'
                                height='18'
                                fill='currentColor'
                                className='bi bi-search'
                                viewBox='0 0 16 16'
                            >
                                <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
                            </svg>
                        </div>
                        <div>
                            <b>BUSCAR</b>
                        </div>
                    </div>
				</div>
			</div>
		</div>
	);
}
